<template>
  <div class="mt-2" style="position: relative">
    <!-- copre l'intera tabella: z-index sopra le celle sticky di b-table -->
    <div
      v-if="loadingSpunte"
      style="
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(239, 242, 244, 0.85);
        border-radius: 4px;
        z-index: 10;
      "
    >
      <div class="custom-loader"></div>
    </div>
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template v-if="newInsurancePaymentBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea un
                  nuovo Quietanzamento cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create px-3"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewInsurancePayment"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                >
                  <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea
                </b-button>
              </div>
            </template>
            <template v-else>
              <empty-table
                :isTableInModal="isTableInModal"
                :performedSearch="performedSearch"
                :automaticPerformedSearch="automaticPerformedSearch"
                :filterCount="filterCount"
              />
            </template>
          </template>
          <template v-slot:head(check)="" v-if="hasChecks && !isCheckExclusive">
            <base-checkbox
              v-model="checkAll"
              name="all"
              class="check"
              @change="onSelectAllRows"
            />
          </template>
          <template #cell(check)="row" v-if="hasChecks">
            <base-checkbox
              name="check"
              class="check"
              v-model="row.item.check"
              @input="onSelectRow($event, row.index, row.item)"
            />
          </template>

          <template #cell(anomalie)="{ item }" v-if="items.length">
            <span v-html="getVirtualValue('errors', item)"></span>
          </template>

          <template #cell(diff)="{ item }" v-if="items.length">
            {{ getVirtualValue("diff", item) }}
          </template>

          <template #cell(insurer_code)="{ item }" v-if="items.length">
            {{ getVirtualValue("insurer_code", item) }}
          </template>

          <template #cell(perc)="{ item }" v-if="items.length">
            {{ getVirtualValue("perc", item) }}
          </template>

          <template #cell(ultimo)="{ item }" v-if="items.length">
            {{ getVirtualValue("ultimo", item) }}
          </template>

          <template #cell(coass)="{ item }" v-if="items.length">
            <!-- data[0].payable.insurance_ancillaries[0].insurance_policy.sharing -->
            {{ getVirtualValue("sharing", item) }}
          </template>

          <template #cell(expired_at)="{ item }" v-if="items.length">
            {{ getVirtualValue("referring_at", item) }}
          </template>

          <template #cell(payment_type)="{ item }" v-if="items.length">
            {{ getPaymentTypeCustom(item.payment_type.text) }}
          </template>

          <template #cell(payment_splitting)="{ item }" v-if="items.length">
            {{ getVirtualValue("payment_splitting_text", item) }}
          </template>

          <template #cell(number)="{ item }" v-if="items.length">
            {{ getVirtualValue("number", item) }}
          </template>

          <template #cell(branch_and_type)="{ item }" v-if="items.length">
            <span>{{ getVirtualValue("branch_and_type", item) }}</span>
          </template>

          <template #cell(produttore)="{ item }" v-if="items.length">
            {{ getBroker(item) }}
          </template>

          <template #cell(contraente)="{ item }" v-if="items.length">
            <span v-html="getVirtualValue('name2', item)"></span>
          </template>

          <template #cell(address_books)="{ item }" v-if="items.length">
            <!-- <span style="white-space: pre-line">{{
              getVirtualValue("contatti", item)
            }}</span> -->
            <span
              class="grid-wrapper"
              :title="contattiTitle(item)"
              v-html="renderContatti(item)"
            ></span>
          </template>

          <template #cell(gruppo)="{ item }" v-if="items.length">
            {{ getVirtualValue("gruppo", item) }}
            <b-icon
              icon="award"
              font-scale="1.5"
              title="È Capogruppo"
              v-if="isCoordinator(item)"
            ></b-icon>
          </template>

          <template #cell(communication)="{ item }" v-if="items.length">
            <div class="d-flex align-items-center" style="gap: 2px">
              <span
                v-for="(obj, index) in getVirtualValue('communication', item)"
                :key="index"
                :title="obj.title"
              >
                <template v-if="obj?.icon === 'missing-capogruppo'">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="18px"
                    viewBox="0 0 122.88 121.42"
                  >
                    <path
                      d="M81.355,75.376c-.62-3.15,6.65-13.69,8.56-19.26,2.98-4.74,4.81-13.81,1.27-18.93-2.12-3.06-1.22-10.21-1.22-14.1,0-30.78-53.92-30.77-53.92,0,0,3.09.62,11.28-.84,13.53-3.67,5.65-2.47,14.15.89,19.5,1.57,5.3,8.41,16.36,8.07,19.26C42.655,88.226,10.505,97.116.005,101.786v19.63l122.87-.01v-22.23c-9.39-4.17-39.21-12.06-41.52-23.8ZM68.249,76.582c0,3.845-3.117,6.962-6.962,6.962s-6.962-3.117-6.962-6.962h0c0-3.845,3.117-6.962,6.962-6.962s6.962,3.117,6.962,6.962h0ZM74.144,55.573c-2.517,2.008-4.116,3.602-4.779,4.82-.65,1.199-.986,2.785-.986,4.729h-14.224v-1.417c0-2.417.268-4.384.818-5.892.55-1.522,1.367-2.889,2.453-4.138,1.086-1.254,3.525-3.453,7.323-6.596,2.022-1.649,3.03-3.157,3.03-4.525,0-1.381-.409-2.439-1.213-3.207-.818-.754-2.044-1.136-3.693-1.136-1.776,0-3.234.586-4.397,1.763-1.163,1.163-1.903,3.221-2.226,6.133l-14.528-1.803c.5-5.342,2.439-9.635,5.815-12.897,3.384-3.257,8.577-4.879,15.564-4.879,5.442,0,9.826,1.136,13.174,3.398,4.538,3.08,6.814,7.169,6.814,12.284,0,2.121-.586,4.179-1.763,6.146-1.163,1.967-3.566,4.384-7.182,7.219Z"
                      fill="#e84242"
                      fill-rule="evenodd"
                    />
                  </svg>
                </template>
                <template v-else>
                  <b-icon
                    font-scale="1.5"
                    :icon="obj.icon"
                    :variant="`${obj?.red ? 'danger' : ''}`"
                  ></b-icon>

                  <b-icon
                    v-if="obj.icon === 'slash-square'"
                    font-scale="1.25"
                    icon="dash-circle-fill"
                    variant="danger"
                  ></b-icon>

                  <b-icon
                    v-if="obj.default"
                    font-scale="1.25"
                    icon="star-fill"
                    variant="warning"
                  ></b-icon>
                  <span
                    v-if="
                      index < getVirtualValue('communication', item).length - 1
                    "
                  >
                    &xrarr;
                  </span>
                </template>
              </span>
            </div>
          </template>

          <template #cell(commento)="{ item }" v-if="items.length">
            <base-icon
              name="loading"
              width="15"
              height="15"
              class="hide-it"
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                translate: -50% -50%;
              "
            />
            <div
              contenteditable="true"
              @input="onInputChange($event, item)"
              @blur="updateComment($event, item)"
              v-html="renderComment(item.comment)"
            ></div>
          </template>

          <template #cell(info)="row">
            <div class="icons-wrapper">
              <!-- Note -->
              <div
                v-if="getVirtualValue('info', row.item).notes"
                role="button"
                class="info-box"
                @click="customOpenNoteModal(row.item, row.index, $event.target)"
                v-b-tooltip="getVirtualValue('info', row.item).notes.content"
              >
                {{ getVirtualValue("info", row.item).notes_counter.content }}
              </div>
              <!-- Incassabile: è un flag del titolo, non della quietanza -->
              <div
                class="info--box"
                v-if="ancillaryOf(row.item)"
                :style="
                  isConsolidated(ancillaryOf(row.item))
                    ? null
                    : 'cursor: pointer'
                "
                @click="onToggleToCollect(row.item)"
              >
                <b-icon
                  font-scale="1.5"
                  :title="toCollectTitle(ancillaryOf(row.item))"
                  :icon="toCollectIcon(ancillaryOf(row.item))"
                  :variant="toCollectVariant(ancillaryOf(row.item))"
                ></b-icon>
              </div>
              <!-- Indirizzo -->
              <div class="info--box" v-if="!hasSameAddress(row.item)">
                <base-icon name="difference" width="18" height="18" />
              </div>
              <!-- Polizza Sostituita -->
              <div
                class="info--box"
                style="cursor: pointer"
                v-if="
                  row.item.payable.insurance_policy
                    ? row.item.payable.insurance_policy.status_policy.value ===
                      3
                    : false
                "
                @click="
                  openReplacedPolicyDetailModal(
                    row.item?.payable?.insurance_policy?.id,
                  )
                "
              >
                <b-icon
                  font-scale="1.5"
                  title="Polizza Sostituita"
                  icon="bell-fill"
                ></b-icon>
              </div>
              <!-- Forzatura Stato -->
              <div class="info--box" v-if="row.item.modified.value === 'Y'">
                <b-icon
                  font-scale="1.5"
                  title="Forzatura Stato"
                  icon="flag-fill"
                  variant="danger"
                ></b-icon>
              </div>
              <!-- Sepa/Rid (OLD) -->
              <div
                class="info--box"
                style="display: none !important"
                v-if="
                  row.item?.payable?.insurance_policy?.bank_accounts &&
                  row.item.payable.insurance_policy.bank_accounts.length
                    ? true
                    : false
                "
              >
                <base-icon name="sepa" width="20" height="20" />
              </div>
              <!-- Sepa/Rid (BE) -->
              <div
                class="info--box"
                v-if="row.item.sepa_sdd === 'Y' ? true : false"
              >
                <base-icon name="sepa" width="20" height="20" />
              </div>
              <!-- Convenzione -->
              <div
                class="info--box"
                v-if="
                  row.item?.payable?.insurance_policy
                    ? row.item?.payable?.insurance_policy?.attributables.CONV
                    : false
                "
              >
                <b-icon
                  font-scale="1.5"
                  :title="
                    row.item?.payable?.insurance_policy?.attributables.CONV
                  "
                  icon="bag"
                ></b-icon>
              </div>
              <!-- Premio Modificato-->
              <div
                v-if="getVirtualValue('info', row.item).premium"
                class="info-box"
                v-b-tooltip="{
                  title:
                    '<b>' +
                    getVirtualValue('info', row.item).premium.header +
                    '</b><br/>' +
                    getVirtualValue('info', row.item).premium.content,
                  placement: 'left',
                  html: true,
                }"
              >
                <b-icon icon="currency-euro" variant="danger"></b-icon>
              </div>
              <!-- Quietanze inviate -->
              <div v-if="row.item?.sent.value === 'Y'" class="info--box">
                <b-icon
                  icon="telegram"
                  font-scale="1.5"
                  title="Quietanza inviata con successo"
                  variant="success"
                ></b-icon>
              </div>
            </div>
          </template>
          <!-- spunta/toglie la spunta alle sole quietanze della pagina corrente -->
          <template #head(selezionato)>
            <b-form-checkbox
              class="check"
              :key="headCheckKey"
            :checked="isPageSelected"
              :indeterminate="isPagePartiallySelected"
              :disabled="!pageSelectableItems.length || loadingSpunte"
              title="Spunta/togli spunta alle quietanze di questa pagina"
              @change="spuntaPagina"
            />
          </template>
          <!-- use @change not @input in order to trigger only user interaction -->
          <template #cell(selezionato)="{ item }">
            <template v-if="item?.status_payment?.value === 0">
              <input type="hidden" :value="calculateItemSelected(item)" />
              <base-icon
                name="loading"
                width="15"
                height="15"
                class="hide-it"
                style="position: relative; top: -2px"
              />
              <base-checkbox
                :ref="`cbx-${item.id}`"
                name="selected"
                class="check"
                v-model="item.selected.value"
                chk_val="Y"
                unchk_val="N"
                @change="onSelezionato($event, item)"
              />
            </template>
            <template v-else></template>
          </template>

          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="
                  actions.includes('infomodal') &&
                  (row.item?.payment_type?.value === 2 ||
                    row.item?.payment_type?.value === 4)
                "
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('details')"
                size="sm"
                variant="lisaweb"
                @click="row.toggleDetails"
                class="mt-1 mr-1"
                :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
              >
                <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
                <b-icon v-else icon="chevron-down"></b-icon>
              </b-button>

              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id)"
                class="mt-1 mr-1"
                title="Modifica"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button>

              <!-- Incassabile (flag del titolo), come nelle azioni dei Titoli:
                   la stessa icona resta anche nelle Info. Solo dove la pagina
                   gestisce il cambio (non nel consolidamento). -->
              <span
                v-if="ancillaryOf(row.item) && $listeners.toggle_to_collect"
                class="d-inline-flex align-items-center"
                :style="
                  isConsolidated(ancillaryOf(row.item))
                    ? null
                    : 'cursor: pointer'
                "
                @click="onToggleToCollect(row.item)"
              >
                <b-icon
                  font-scale="1.5"
                  :title="toCollectTitle(ancillaryOf(row.item))"
                  :icon="toCollectIcon(ancillaryOf(row.item))"
                  :variant="toCollectVariant(ancillaryOf(row.item))"
                ></b-icon>
              </span>

              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id)"
                class="mt-1 mr-1"
                title="Elimina"
                :disabled="row.item?.payment_type?.value !== 4"
              >
                <base-icon name="trash" width="22" height="22"></base-icon>
              </b-button>

              <b-button
                size="sm"
                variant="lisaweb"
                class="mt-1 mr-1"
                title="Modifica gruppo"
                @click="
                  customOpenGroupModal(row.item, row.index, $event.target)
                "
                :disabled="evaluateGroup(row.item)"
              >
                <b-icon icon="people-fill"></b-icon>
              </b-button>

              <b-button
                size="sm"
                variant="lisaweb"
                @click="customOpenAddressBookModal(row)"
                class="mt-1 mr-1"
                title="Modale dettagli corrispondenza"
              >
                <b-icon icon="person-square" width="16" height="16" />
              </b-button>

              <b-button
                size="sm"
                variant="lisaweb"
                @click="onChosen(row.item)"
                class="mt-1 mr-1"
                :disabled="
                  row.item.status_payment.value == 3 ||
                  row.item.status_payment.value == 4
                "
                :title="
                  'Cambia in ' +
                  (row.item.status_payment.value == 1 ||
                  row.item.status_payment.value == 2
                    ? 'valido'
                    : 'da validare')
                "
              >
                <b-icon icon="arrow-repeat"></b-icon>
              </b-button>
            </div>
          </template>

          <template #row-details="row">
            <b-card>
              <b-row class="mb-2" v-for="(value, key) in row.item" :key="key">
                <b-col sm="3" class="text-sm-right"
                  ><b>{{ key | capitalize }}:</b></b-col
                >
                <b-col>{{ value }}</b-col>
              </b-row>
            </b-card>
          </template>
          <template v-slot:[`cell(status_payment.text)`]="{ item }">
            <status-badge kind="payment" :status="item.status_payment" />
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <!-- Pulsanti di selezione e paginazione sulla stessa riga. -->
      <div class="table-footer">
        <div v-if="hasChecksButtonGroup" class="spunte-wrapper">
          <b-button-group
            class="spunte-group"
            size="md"
            style="display: flex; align-items: center; max-width: max-content"
          >
            <b-button
              class="btn--transparent btn--smaller spunte-button"
              @click="spuntaTutte()"
              :disabled="loadingSpunte"
            >
              <base-icon name="circled_checked" width="20" height="20" />
              Spunta tutte
            </b-button>
            <b-button
              class="btn--transparent btn--smaller spunte-button"
              @click="togliSpuntaTutte()"
              :disabled="loadingSpunte"
            >
              <base-icon name="circled_ko" width="20" height="20" />
              Togli spunte a tutte
            </b-button>
            <slot name="selection-actions" :count="cntr">
              <p class="select-all" style="margin: 0; padding: 5px 10px">
                Selezionate: {{ cntr }}
              </p>
            </slot>
          </b-button-group>
        </div>
        <pagination-skeleton v-if="isLoading && !noPagination" />
        <div
          class="pagination-wrapper"
          v-if="!isLoading && !noPagination && items.length"
        >
          <div class="info">
            <div class="show-text">
              <p>
                <label for="per-page-select-registry"
                  >Numero di risultati per pagina:</label
                >
              </p>
            </div>
            <div class="group">
              <b-form-group label-for="per-page-select">
                <b-form-select
                  id="per-page-select-registry"
                  v-model="perPage"
                  :options="pageOptions"
                  style="width: 68px"
                  size="sm"
                  @change="onPageChange(1)"
                  :disabled="!items.length"
                ></b-form-select>
              </b-form-group>
            </div>
            <div class="page">
              <p>
                Risultati da
                <strong>{{ formatItemsFrom }}</strong> a
                <strong>{{ formatItemsTo }}</strong> su un totale di
                <strong>{{ formatTotalItems }}</strong>
              </p>
            </div>
          </div>
          <div class="info-action">
            <div class="pagination" v-if="totalItems">
              <b-pagination
                v-model="currentPage"
                limit="3"
                :total-rows="totalItems"
                :per-page="perPage"
                size="sm"
                @change="onPageChange"
              >
                <template #page="{ page, active }">
                  <span :data-active="active">{{
                    page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }}</span>
                </template>
                <template v-slot:first-text>
                  <span
                    ><base-icon
                      scale="-1"
                      name="chevron_right_last_rounded"
                      width="16"
                      height="16"
                  /></span>
                </template>
                <template v-slot:prev-text>
                  <span
                    ><base-icon
                      scale="-1"
                      name="chevron_right_rounded"
                      width="16"
                      height="16"
                  /></span>
                </template>
                <template v-slot:next-text>
                  <span
                    ><base-icon
                      name="chevron_right_rounded"
                      width="16"
                      height="16"
                  /></span>
                </template>
                <template v-slot:last-text>
                  <span
                    ><base-icon
                      name="chevron_right_last_rounded"
                      width="16"
                      height="16"
                  /></span>
                </template>
              </b-pagination>
            </div>
            <div
              class="input_pagination"
              v-if="
                totalItems && !noInputPaginator && totalPages && totalPages > 3
              "
            >
              <base-input-pagination
                @pagination="onInputPagination"
              ></base-input-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- <b-modal
        :id="infomodalName"
        title="Modifica contatti"
        size="lg"
        scrollable
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  :dbRowData="dbRowData"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal> -->
      <b-modal
        :dialog-class="customModalClass"
        :id="infomodalName"
        @show="onModalShow"
        @hidden="onModalHidden"
        :title="custoModalTitle"
        :size="custoModalSize"
        scrollable
        ok-only
        ok-title="Chiudi"
        ok-variant="-transparent"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <template v-slot:modal-header-close>
          <base-icon name="close" width="14" height="14" />
        </template>
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              :title-item-class="['lisaweb', tab.itemClass]"
            >
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  :dbRowData="dbRowData"
                  v-bind="tab.props"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import template from "./template";
import StatusBadge from "@/components/StatusBadge";
import BaseIcon from "@/components/BaseIcon";
import BaseCheckbox from "@/components/form/BaseCheckbox";
import BaseInputPagination from "@/components/form/BaseInputPagination";
import General from "@/components/insurance-payments/details/General.vue";
import Policy from "@/components/insurance-payments/details/Policy.vue";
import Anagrafica from "@/components/insurance-payments/details/Anagrafica.vue";
import Notes from "@/components/insurance-payments/details/Notes.vue";
import Premio from "@/components/insurance-payments/details/Premio.vue";
import Comment from "@/components/insurance-payments/details/Comment.vue";
import Collect from "@/components/insurance-ancillaries/details/Collect.vue";
import Group from "@/components/insurance-payments/details/Group.vue";
import Sendings from "@/components/communication/sendings/Sendings.vue";
import EmptyTable from "@/components/EmptyTable.vue";
import { getVirtualValue, hasSameAddress } from "@/utils/payments";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { contactIcon, toInfoData } from "@/utils/transforms";

export default {
  name: "InsurancePaymentsTable",
  extends: template,
  data() {
    return {
      customModalClass: "modal-quietanzamento",
      counterSelezionate: 0,
      headCheckKey: 0, // ricrea la checkbox dell'header dallo stato calcolato
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      custoModalTitle: "Dettagli",
      custoModalSize: "xl",
      modalTitleDefault: "Dettagli",
      modalTitleGroup: "Gruppo",
      modalSizeGroup: "md",
      modalSizeDefault: "xl",
      tabs: [
        { name: "General", text: "Generale" },
        { name: "Anagrafica", text: "Anagrafica" },
        { name: "Policy", text: "Polizza" },
        { name: "Notes", text: "Note" },
        { name: "Comment", text: "Commento" },
        { name: "Premio", text: "Modifica Premio" },
        { name: "Collect", text: "Incassabile" },
        // Solo per la modale del gruppo (customOpenGroupModal): nascosta nei dettagli
        { name: "Group", text: "Gruppo", itemClass: "group-tab" },
        {
          name: "Sendings",
          text: "Invii",
          props: { repository: "insurance_payment" },
        },
      ],
      payment_types: [
        { value: "0", full_text: "Quietanza", text: "Q" },
        { value: "1", full_text: "Acconto", text: "A" },
        { value: "2", full_text: "Sospeso", text: "S" },
        { value: "3", full_text: "Manuale", text: "M" },
        { value: "4", full_text: "Arretrato", text: "T" },
      ],
      // insurancePaymentsEditTabs: [
      //   { name: "Contatti", text: "Contatti" },
      //   { name: "Address", text: "Indirizzo di corrispondenza" },
      // ],
      selected: "General", // dynamically load selected component in tabs
      modalResourceId: null, // prop for the dynamic components
      tabIndex: 0, // remember last visited tab: set active tab when modal gets opened
      dbRowData: null, // used to pass the actual record to tabs
    };
  },
  components: {
    StatusBadge,
    BaseIcon,
    BaseInputPagination,
    BaseCheckbox,
    General,
    Anagrafica,
    Policy,
    Notes,
    Comment,
    EmptyTable,
    Premio,
    Collect,
    Group,
    Sendings,
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    isChecked() {
      return (item) => {
        return item.selezionato;
      };
    },
    cntr() {
      return this.counterSelezionate;
    },
    /* Stesse righe su cui compare la checkbox "Selezionato" */
    pageSelectableItems() {
      return this.items.filter((item) => item?.status_payment?.value === 0);
    },
    /*
     * Si conta su users e non su selected: selected può essere aggiunto da
     * calculateItemSelected() durante il render e in quel caso non è reattivo
     */
    pageSelectedCount() {
      return this.pageSelectableItems.filter((item) => item?.users?.length)
        .length;
    },
    isPageSelected() {
      return (
        this.pageSelectableItems.length > 0 &&
        this.pageSelectedCount === this.pageSelectableItems.length
      );
    },
    isPagePartiallySelected() {
      return this.pageSelectedCount > 0 && !this.isPageSelected;
    },
  },
  mounted() {},
  watch: {
    /*
     * b-form-checkbox cambia il proprio stato interno al click e non lo riallinea se
     * il valore calcolato non cambia (es. salvataggio fallito): a fine salvataggio
     * si ricrea la checkbox dell'header, così riparte da isPageSelected/indeterminate
     */
    loadingSpunte(newVal, oldVal) {
      if (!newVal && oldVal) this.headCheckKey++;
    },
  },
  props: {
    hasChecksButtonGroup: {
      default: true,
      type: Boolean,
    },
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    loadingSpunte: {
      type: Boolean,
      default: false,
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    saveRelationBtn: {
      type: Boolean,
      default: false,
    },
    hasChecksPaginated: {
      type: Boolean,
      default: false,
    },
    newInsurancePaymentBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toInfoData,
    getVirtualValue,
    hasSameAddress,
    renderComment(comment) {
      return comment && comment.length ? comment.replace(/\n/g, "<br>") : "";
    },
    onInputChange(event, item) {
      const trimmed_new_comment = event.target.innerText.trim();
      if (item.comment != trimmed_new_comment) {
        event.target.classList.add("edited-field");
      } else {
        event.target.classList.remove("edited-field");
      }
    },
    updateComment(event, item) {
      const trimmed_new_comment = event.target.innerText.trim();
      if (
        (!item.comment && !trimmed_new_comment) ||
        item.comment === trimmed_new_comment
      ) {
        /* Do nothing
         *  if the field was empty and will remain empty
         *  OR
         *  if the fields has a value and will remain the same
         */
        if (event.target.classList.contains("edited-field"))
          event.target.classList.remove("edited-field");
        return;
      }
      item.comment = trimmed_new_comment;
      if (
        event.target &&
        event.target.previousElementSibling &&
        event.target.previousElementSibling.matches(".hide-it")
      ) {
        event.target.classList.add("hide-it-light");
        event.target.previousElementSibling.classList.remove("hide-it");
      }
      this.$emit("updateComment", item, event.target);
    },
    evaluateGroup(item) {
      const groupName = getVirtualValue("gruppo", item);
      return !groupName || groupName === "-" ? false : true;
    },
    getPaymentTypeCustom(text) {
      return this.payment_types.find((p) => p.full_text === text).text;
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    onAddNewInsurancePayment() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    renderContatti(item) {
      let registry;
      let ret = "-";
      registry = item?.payable?.insurance_policy?.registry;
      if (registry) {
        const address_books = registry?.address_books;
        const primary_address_book = address_books.find(
          (address_book) => address_book.status_addressbook.value === 0,
        );
        const address_book_attrs = primary_address_book?.attributables;
        const cell = address_book_attrs?.CELL;
        const email = address_book_attrs?.MAIL;
        if (!cell && !email) return ret;
        // Cellulare ed email sempre visibili; tutti i recapiti nel title
        // (contattiTitle).
        ret = `
        ${contactIcon("CELL")} <span>${cell ?? "-"}</span>
        ${contactIcon("MAIL")} <span>${email ? email.toLowerCase() : "-"}</span>
        `;
      } else {
        console.log("No registry in item.payable.insurance_policy.registry");
        // debugger;
      }
      return ret;
    },
    contattiTitle(item) {
      const attrs = item?.payable?.insurance_policy?.registry?.address_books?.find(
        (address_book) => address_book.status_addressbook.value === 0,
      )?.attributables;
      return [
        ["Tel", attrs?.PHON],
        ["Cell", attrs?.CELL],
        ["Email", attrs?.MAIL?.toLowerCase()],
        ["PEC", attrs?.PEC?.toLowerCase()],
      ]
        .filter(([, value]) => value)
        .map(([label, value]) => `${label}: ${value}`)
        .join(" · ");
    },
    customOpenAddressBookModal(row) {
      // openNoteDetailModal(array) {
      console.log("openModal", row);
      this.$emit("open_address_book", row);
      // },
      // console.log("openModal", index);
      // console.log("openModal", target);
      // this.$bvModal.show("modalEditAddressBook");
      // this.openModal(item, index, target);
    },
    onModalShow() {
      if (this.tabIndex < this.tabs.length)
        this.setTab(this.tabs[this.tabIndex], this.tabIndex);
    },
    onModalHidden() {
      this.setTab({ name: "General", text: "Generale" }, 0);
      this.customModalClass = "modal-quietanzamento";
      this.custoModalTitle = this.modalTitleDefault;
      this.custoModalSize = this.modalSizeDefault;
    },
    customOpenNoteModal(item, index, target) {
      this.tabIndex = 3; // TabIndex ID delle Note
      this.openModal(item, index, target);
    },
    customOpenGroupModal(item, index, target) {
      this.tabIndex = 7; // TabIndex ID del Gruppo
      this.custoModalTitle = this.modalTitleGroup;
      this.custoModalSize = this.modalSizeGroup;
      this.customModalClass += " group-tab-open";
      this.openModal(item, index, target);
    },
    calculateItemSelected(item) {
      if (!item.selected) item["selected"] = { text: "", value: null };
      item.selected.value = item.users.length ? "Y" : "N";
      item.selected.text = item.users.length ? "Si" : "No";
    },
    loadSelectedCounter() {
      const userId = this.$store.state.auth.user.id;
      let queryString = `byUser[id]=${userId}&count`;
      let Repo = RepositoryFactory.get("insurance_payment");
      return Repo.index(queryString)
        .then((response) => {
          this.counterSelezionate = response.data.data.count;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onSelezionato(value, item) {
      const checkboxElement = this?.$refs?.[`cbx-${item.id}`]?.$el;
      if (
        checkboxElement &&
        checkboxElement.previousElementSibling &&
        checkboxElement.previousElementSibling.matches(".hide-it")
      ) {
        checkboxElement.previousElementSibling.classList.remove("hide-it");
        checkboxElement.classList.add("hide-it");
      }
      // console.debug("onSelezionato");
      console.debug(value, item);
      /* */
      if (!item.selected) item["selected"] = { text: "", value: null };
      item.selected.value = value === "Y" ? "Y" : "N";
      item.selected.text = value === "Y" ? "Si" : "No";
      /* */
      this.$emit("selezionato", item, checkboxElement);
    },
    spuntaTutte() {
      this.$emit("spunta");
    },
    /* Da parzialmente spuntata il click spunta tutte le righe della pagina */
    spuntaPagina(checked) {
      this.$emit("spuntapagina", checked ? "Y" : "N");
    },
    togliSpuntaTutte() {
      this.$emit("toglispunta");
    },
    info(item, index, button) {
      // TODO: check if it's possible perform async calls here!!!
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      // this.$root.$emit("bv::show::modal", this.infoModal.id, button);
      this.$bvModal.show(this.infoModal.id, button);
    },
    getBroker(item) {
      let brokerId = null;
      if (item.payable_type.includes("BookEntry")) {
        brokerId = item?.payable?.brokers[0]?.id;
      } else {
        brokerId = item?.payable?.insurance_policy?.broker_id;
      }
      if (brokerId) {
        const broker = this.$store.state.auth.salesmen.find(
          (salesman) => salesman.id === brokerId,
        );
        return broker ? toInfoData(broker, "broker", 0) : "";
      }
      return "";
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    openReplacedPolicyDetailModal(policy_id) {
      this.$emit("open_replaced_policy", policy_id);
    },
    /*
     * Il titolo della quietanza. Il payload lo porta come "payable" (relazione polimorfa già
     * eager-loaded dai filtri della griglia); per le quietanze legate a un BookEntry non c'è
     * titolo, e quindi nessun flag da mostrare.
     */
    ancillaryOf(item) {
      const payable = item?.payable;
      return payable && payable.to_collect ? payable : null;
    },
    isConsolidated(ancillary) {
      return ancillary?.consolidated?.value === "Y";
    },
    /* Spunta se incassabile, X se non incassabile */
    toCollectIcon(ancillary) {
      return ancillary?.to_collect?.value === "Y" ? "check" : "x";
    },
    /* Grigio finché il titolo non è consolidato, poi verde/rosso secondo l'incassabilità */
    toCollectVariant(ancillary) {
      if (!this.isConsolidated(ancillary)) return "secondary";
      return ancillary?.to_collect?.value === "Y" ? "success" : "danger";
    },
    toCollectTitle(ancillary) {
      if (this.isConsolidated(ancillary)) {
        return `${
          ancillary?.to_collect?.value === "Y"
            ? "Incassabile"
            : "Non incassabile"
        } - titolo consolidato: modificabile dal dettaglio (occhietto)`;
      }
      return ancillary?.to_collect?.value === "Y"
        ? "Incassabile - clicca per rendere non incassabile"
        : "Non incassabile - clicca per rendere incassabile";
    },
    /* Il toggle vale nei due versi, ma solo finché il titolo non è consolidato */
    onToggleToCollect(item) {
      const ancillary = this.ancillaryOf(item);
      if (!ancillary || this.isConsolidated(ancillary)) return;
      this.$emit("toggle_to_collect", ancillary);
    },
    isCoordinator(item) {
      const registry =
        item.payable?.insurance_policy?.registry ??
        item.payable?.registries?.[0];

      if (!registry) {
        return false;
      }

      return registry.registry_groups.find(
        (registry_group) => registry_group.pivot.is_coordinator.value === "Y",
      );
    },
  },
};
</script>
<style>
@supports (position: sticky) {
  [data-table="quietanzamento"] .table.b-table > tbody > tr > td {
    background-color: inherit !important;
  }
}

[data-table="quietanzamento"] td div[contenteditable] {
  field-sizing: content;
  overflow: hidden;
  height: auto;
  padding: 6px;
  font-size: 11px;
  background-color: #fff;
  border: 1px solid var(--gray-300);
  border-radius: 0.25rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}

[data-table="quietanzamento"] td div[contenteditable].edited-field {
  border-color: orange;
}

[data-table="quietanzamento"]
  td
  div[contenteditable].edited-field:focus-visible {
  outline-color: orange;
}
</style>
<style lang="scss" scoped>
@import "~@/assets/css/table-mixins";
@include table-check-column;

.select-all {
  font-size: var(--font-size-sm);
  margin-top: 7px;
  margin-left: 8px;
  background: none;
}

.check-icon {
  color: green;
}

.cross-icon {
  color: red;
}

.text-decoration-none {
  font-size: var(--font-size-sm);
}

@include table-form-group;

:deep(input[type="checkbox"]) {
  cursor: pointer;
}

:deep(.hide-it) {
  display: none;
}

:deep(.hide-it-light) {
  opacity: 0;
  visibility: hidden;
  cursor: default;
  pointer-events: none;
  touch-action: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

// Info: stessa misura e spaziatura delle azioni (bottoni da 21px a 4px,
// icone da 19px).
:deep(.icons-wrapper) {
  display: grid;
  grid-template-columns: repeat(2, 21px);
  gap: 4px;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 21px;
    height: 21px;
    margin: 0;
  }

  svg {
    width: 19px;
    height: 19px;
  }
}

:deep(.grid-wrapper) {
  display: grid;

  // Icone dei contatti: lo spazio lo dà già .contact-icon (_tables.scss).
  &:has(> .contact-icon) {
    grid-column-gap: 0;
  }

  // grid-template-columns: repeat(2, max-content);
  grid-template-columns: repeat(
    2,
    minmax(auto, max-content)
  ); /* Multi-row / Wrap */
  grid-row-gap: 0px;
  grid-column-gap: 10px;
}

:deep(table td:last-child) {
  &.b-table-sticky-column {
    left: auto;
    right: 0;
  }
}

:deep(table th:last-child) {
  &.b-table-sticky-column {
    left: auto;
    right: 0;
  }
}

:deep(table th[aria-colindex="21"]) {
  &.b-table-sticky-column {
    left: auto;
    right: 60px;
  }
}

:deep(table td[aria-colindex="21"]) {
  &.b-table-sticky-column {
    left: auto;
    right: 60px;
  }
}
</style>
